export const getSegmentErrorCode = (error) => {
    const data = error?.response?.data;
    const errors = data?.errors;
    const firstError = Array.isArray(errors) ? errors[0] : errors;
    return data?.error ?? firstError ?? data?.detail ?? null;
};
